<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="ag-grid-demo">
        <div class="flex flex-wrap justify-between items-center mb-5">
<!--            <div class="mb-5 md:mb-0 mr-5 ag-grid-table-actions-left" style="display: flex">
                <div class="con-select select-large" style="width: auto">
                    <div class="input-select-con">
                        <select v-model="year" @change="refresh" class="input-select vs-select&#45;&#45;input" style="padding: 8.8px;">
                            <option :key="index" :value="item" v-for="(item,index) in years">{{ item }}</option>
                        </select>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div v-if="userInfo.type_id === 1" class="con-select select-large" style="width: auto">
                    <div class="input-select-con">
                        <select v-model="country_id" @change="refresh" class="input-select vs-select&#45;&#45;input">
                            <option :key="index" :value="item.id" v-for="(item,index) in countries">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <vs-checkbox v-model="markup">&nbsp;{{ $t('Markup') }}</vs-checkbox>
            </div>-->

        </div>

        <div class="vx-row m-0">
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Company Name</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Markup</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Reseller</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Customer</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Subscriptions</div>
        </div>

        <div v-for="(item) in items" id="category_tree">
            <vx-card class="mt-5">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/5 w-full">{{ item.company_name }}</div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                </div>

                <div v-if="item.childs" v-for="(reseller) in item.childs" class="ml-5 mt-2" :class="'child_'+reseller.id" style="border-top:1px solid black">
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/5 w-full">{{ reseller.company_name }}</div>
                        <div class="vx-col sm:w-1/5 w-full">{{ reseller.markup.title }}</div>
                        <div class="vx-col sm:w-1/5 w-full">
                            <vs-button @click="getResellerInformation(reseller.reseller)" class="btn-drop" type="flat" size="small" color="primary" icon-pack="feather" icon="icon-eye"></vs-button>
                        </div>
                        <div class="vx-col sm:w-1/5 w-full"></div>
                        <div class="vx-col sm:w-1/5 w-full"></div>
                    </div>

                    <div v-if="reseller.childs" v-for="(customer) in reseller.childs" class="ml-5" :class="'child_'+customer.id">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/5 w-full">{{ customer.company_name }}</div>
                            <div class="vx-col sm:w-1/5 w-full">{{ customer.markup.title }}</div>
                            <div class="vx-col sm:w-1/5 w-full"></div>
                            <div class="vx-col sm:w-1/5 w-full">
                                <vs-button @click="getCustomerInformation(customer.customer)" class="btn-drop" type="flat" size="small" color="primary" icon-pack="feather" icon="icon-eye"></vs-button>
                            </div>
                            <div class="vx-col sm:w-1/5 w-full">
                                <vs-button @click="getCustomerISubscriptions(customer.customer)" class="btn-drop" type="flat" size="small" color="primary" icon-pack="feather" icon="icon-eye"></vs-button>
                            </div>
                        </div>
                    </div>

                </div>

            </vx-card>
        </div>


        <div>
            <vs-popup class="holamundo" v-bind:title="modalTitle" :active.sync="openPopup">
                <pre>{{ JSON.stringify(popupDetails, null, 2) }}</pre>
            </vs-popup>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            userInfo: window.userInfo,
            openPopup: false,
            modalTitle: '',
            items: [],
            popupDetails: {},
        }
    },

    created() {
        this.$vs.loading();
        const thisIns = this;
        thisIns.getData();

    },
    methods: {
        getData(){
            this.$vs.loading();
            const thisIns = this;

            axios.get(apiUrl+'/adobe/get-all-users-list?token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.items = data.data;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
        getResellerInformation(reseller){
            this.modalTitle = 'Reseller Information';
            this.popupDetails = reseller;
            this.openPopup = true;
        },
        getCustomerInformation(customer){
            this.modalTitle = 'Customer Information';
            this.popupDetails = customer;
            this.openPopup = true;
        },
        getCustomerISubscriptions(customer){
            this.modalTitle = 'Customer Subscriptions';
            this.$vs.loading();
            const thisIns = this;

            console.log(customer);

            axios.get(apiUrl+'/adobe/get-customer-subscription?&adobeId='+customer.customerId+'&token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.popupDetails = data.data;
                        thisIns.openPopup = true;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        }
    },
}

</script>


<style lang="scss" scoped>

#category_tree{
    .child{
        display: none;
        &.active{
            display: block;
        }
    }
    .text-bold{
        font-weight: bold;
    }
    .color-green{
        color: #43a047;
    }
}


.vs-table--tbody{
    border: 0 !important;

    .vs-table--tbody-table{
        .vs-table--thead th{
            border-bottom: 1px solid #e2e2e2;
        }
        .tr-values td{
            border-bottom: 1px solid #e2e2e2;
        }
    }

    .text-bold{
        font-weight: bold;
    }
    .color-green{
        color: #43a047;
    }
}
</style>
